import {
  Box,
  Heading,
  Container,
  Text,
  Button,
  Stack,
  Flex,
} from '@chakra-ui/react';
import { Link as ScrollLink } from 'react-scroll';
import ImageCompare from '../ImageCompare'; // Ajuste o caminho conforme necessário
import { Link as RouterLink } from 'react-router-dom';

const Hero = () => {
  return (
    <Box
      as="section"
      position="relative"
      pt={{ base: "100px", md: "150px" }}
      pb={{ base: "60px", md: "80px" }}
      bg="gray.50"
      overflow="hidden"
    >
      {/* Background decorations */}
      <Box
        position="absolute"
        top="-100px"
        right="-100px"
        width="300px"
        height="300px"
        borderRadius="full"
        bg="brand.accent1"
        opacity="0.2"
      />
      <Box
        position="absolute"
        bottom="-100px"
        left="-100px"
        width="300px"
        height="300px"
        borderRadius="full"
        bg="brand.accent2"
        opacity="0.2"
      />

      <Container maxW="1200px" position="relative" zIndex={1}>
        <Flex
          align="center"
          direction={{ base: "column", md: "row" }}
          gap={{ base: 8, md: 12 }}
        >
          <Box
            flex={1}
            w={{ base: "100%", md: "50%" }}
            order={{ base: 2, md: 1 }}
          >
            <Heading
              as="h1"
              fontSize={{ base: "2xl", md: "4xl", lg: "5xl" }}
              mb={4}
              bgGradient="linear(to-r, brand.primary, brand.secondary)"
              bgClip="text"
            >
              Transforme suas memórias em arte para colorir
            </Heading>
            <Text fontSize={{ base: "md", md: "xl" }} color="gray.600" mb={6}>
              Crie desenhos personalizados a partir das suas fotos e reconecte-se com
              momentos especiais enquanto desfruta da calma que colorir proporciona.
            </Text>
            <Stack
              direction={{ base: "column", sm: "row" }}
              spacing={4}
              justify={{ base: "center", md: "flex-start" }}
            >
              <Box as={ScrollLink} to="precos" smooth={true} duration={500}>
                <Button
                  as={RouterLink}
                  to="/signup"
                  size={{ base: "md", md: "lg" }}
                  bgGradient="linear(to-r, brand.primary, brand.secondary)"
                  color="white"
                  _hover={{
                    transform: 'translateY(-3px)',
                    boxShadow: '0 5px 15px rgba(165, 180, 232, 0.4)',
                  }}
                  borderRadius="full"
                  px={8}
                  w={{ base: "full", md: "auto" }}
                >
                  Começar agora
                </Button>
              </Box>
              <Box as={ScrollLink} to="como-funciona" smooth={true} duration={500}>
                <Button
                  size={{ base: "md", md: "lg" }}
                  variant="outline"
                  borderColor="brand.primary"
                  color="brand.primary"
                  _hover={{
                    bg: "brand.primary",
                    color: "white",
                  }}
                  borderRadius="full"
                  px={8}
                  w={{ base: "full", md: "auto" }}
                >
                  Como funciona
                </Button>
              </Box>
            </Stack>
          </Box>
          <Box
            flex={1}
            h={{ base: "250px", md: "350px" }}
            w={{ base: "100%", md: "50%" }}
            order={{ base: 1, md: 2 }}
            mb={{ base: 4, md: 0 }}
          >
            <ImageCompare
              beforeImage="/img/original-photo.png" // Substitua pelo caminho da sua imagem original
              afterImage="/img/drawing-version.png" // Substitua pelo caminho da versão desenho
            />
          </Box>
        </Flex>
      </Container>
    </Box>
  );
};

export default Hero;